import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { forwardRef, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import IconButton from './Base/IconButton.js';
import IconChat from '../../svg/IconChat.js';
import { dlsDeepBlueBg } from '../../styles/colorsDls/dlsDeepBlueBg.js';
import btnFloat from '../../styles/btnFloat.js';
import btn from '../../styles/btn.js';
import btnFloatingChat from '../../styles/btnFloatingChat.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var ButtonFloatingChat = /*#__PURE__*/forwardRef(function (props, ref) {
  var children = props.children,
      theme = props.theme,
      otherProps = _objectWithoutProperties(props, ["children", "theme"]);

  var styleObject = _objectSpread(_objectSpread(_objectSpread({}, dlsDeepBlueBg), btn), btnFloat.btnFloat);

  var cssStyle = useMemo(function () {
    return merge.all([btnFloatingChat.btnFloatingChat, {
      // get the styles for each screen size
      '@media (min-width: 375px)': btnFloatingChat['@media (min-width: 375px)'].btnFloatingChat,
      '@media (min-width: 768px)': btnFloatingChat['@media (min-width: 768px)'].btnFloatingChat,
      '@media (min-width: 1024px)': btnFloatingChat['@media (min-width: 1024px)'].btnFloatingChat,
      '@media (min-width: 1280px)': btnFloatingChat['@media (min-width: 1280px)'].btnFloatingChat
    }, theme]);
  }, [theme]);
  return jsx("div", {
    css: cssStyle
  }, jsx(IconButton, _extends({}, otherProps, {
    ref: ref,
    icon: jsx(IconChat, null),
    theme: styleObject,
    styled: true
  }), children));
});
ButtonFloatingChat.defaultProps = {
  theme: {},
  children: ''
};

export default ButtonFloatingChat;
